/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect, useState } from 'react'
import { ga_push, vPush } from '../../../services/analytics';
import { SendLead } from '../../../services/fetch';
import { Environment } from '../../../services/urls';
import { AppContext } from '../../../stores/application.store';
import Question from './Question/Question';
import "./QuestionsPage.scss";


const QuestionsPage = () => {



    const { questionIndex, quizData, quizAnswers, user, setPageView, quizTime } = useContext(AppContext)!;
    const [page, setPage] = useState(1);
    const [isLastPage, setIsLastPage] = useState(false);


    const loadGoogleRecaptcha = () => {
        if (Environment() !== "local") {
            (() => {
                if (window.document.getElementById("GoogleRecap")) return;

                var script = document.createElement("script");
                script.type = "text/javascript";
                script.id = "GoogleRecap";
                script.async = true;
                script.src = "https://www.google.com/recaptcha/api.js";

                document.getElementsByTagName("head")[0].appendChild(script);
            })();
        }
    };

    useEffect(() => {
        loadGoogleRecaptcha();
        (window as any).sendFormViaCaptcha = sendUserLeadWithCaptcha;
    }, [])

    const sendUserLeadWithCaptcha = () => {
        if (Environment() !== "local") {
            (window as any).grecaptcha.reset()
        }
        sendUserLead();
    }
    const sendUserLead = () => {
        if (quizAnswers.length < page * 6 && !isLastPage) {
            alert("נדרש לענות על כל השאלות")
        } else if (!isLastPage) {
            let topNum: number = 0;
            if ((page + 1) * 6 > quizData!.Questions.length) {
                topNum = quizData!.Questions.length;
            } else {
                topNum = (page + 1) * 6;
            }
            vPush(`questions-${page * 6 + 1}to${topNum}`, `חידון פיפה - שאלות ${page * 6 + 1} עד ${topNum}`)
            setPage(page + 1)
        } else if (quizAnswers.length < quizData!.Questions.length) {
            alert("נדרש לענות על כל השאלות");
        } else {
            let seconds = (new Date().getTime() - quizTime!.getTime()) / 1000;
            seconds = Math.abs(seconds);
            seconds = Math.floor(seconds);
            let answers = quizAnswers.map(x => x.AnswerId);
            SendLead({ ...user, Questions: answers, QuizTime: seconds });
            vPush("thank-you", "חידון פיפה - תודה על ההרשמה")
            ga_push("ga_events", "FIFA", "Quiz", "Finish Quiz");
            setPageView("thank-you");
        }


    }
    useEffect(() => {
        if (quizData && quizData.Questions.length / 6 < page) {
            setIsLastPage(true);
        } else {
            setIsLastPage(false);
        }
    }, [page, quizData])

    return (
        <div className="questions-page">
            <div className="questions-wrapper">
                {quizData &&
                    quizData.Questions!.map((question, index) => (
                        <div className={`${index !== questionIndex ? "hidden-mobile" : ""}
                        ${!(index < page * 6 && index >= (page - 1) * 6) ? "hidden" : ""}`}
                            key={index}>
                            <Question questionIndex={index}></Question>
                        </div>
                    ))}

            </div>
            <div className="button-wrapper hidden-mobile">

                <button className={`next ${isLastPage ? "last-page" : ""}`} onClick={sendUserLead}>

                </button>
                {isLastPage &&
                    <div
                        className="g-recaptcha"
                        data-callback="sendFormViaCaptcha"
                        data-size="invisible"
                        data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
                    ></div>}
            </div>
        </div>
    )
}

export default QuestionsPage
